import { ErrorMessage } from '@hookform/error-message';
import classNames from 'classnames';

import { IFieldErrorProps, IRendererProps } from './interfaces';

export const FieldError = ({
  name,
  errors,
  additionalClassName,
}: IFieldErrorProps) => {
  const className = classNames('contact-form__error', additionalClassName);

  return (
    <ErrorMessage
      errors={errors}
      name={name}
      render={({ message }: IRendererProps) => (
        <p className={className}>{message}</p>
      )}
    />
  );
};
